<template>
  <div class="seneca-section">
    <div class="seneca-text-wrapper">
      <SectionTitle heading="We Believe" />
      <div class="seneca-quote-wrapper">
        <p class="first-quotation">“</p>
        <p class="p-On-the-Shortness-of-Life">
          われわれにはわずかな時間しかないのではなく、多くの時間を浪費するのである。人間の生は、全体を立派に活用すれば、十分に長く、偉大なことを完遂できるよう潤沢に与えられている。
        </p>
        <p class="p-seneca-the-younger"> — ルキウス・アンナエウス・セネカ『生の短さについて』</p>
        <p class="last-quotation">”</p>
      </div>
    </div>
    <div class="seneca-img-wrapper">
      <img src="@/assets/img/about/seneca.png" alt="ルキウス・アンナエウス・セネカ">
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/features/about/components/SectionTitle.vue";

export default {
  name: "SenecaSection",
  components: { SectionTitle },
};
</script>

<style scoped>
.seneca-section {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.seneca-text-wrapper {
  width: 70%;
  height: auto;
  margin-left: 0%;
}

.seneca-img-wrapper {
  width: 30%;
  height: auto;
  display: flex;
  justify-content: center;
}

.seneca-quote-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.first-quotation {
  font-family: "GenEiKoburiMin";
  font-size: 30px;
  color: #493c33;
  text-align: start;
  height: 20px;
}

.last-quotation {
  font-family: "GenEiKoburiMin";
  font-size: 30px;
  color: #493c33;
  text-align: end;
  height: 20px;
}

.p-On-the-Shortness-of-Life {
  font-family: "GenEiKoburiMin";
  font-size: 14px;
  color: #493c33;
  line-height: 1.5rem;
  width: 90%;
  align-self: center;
}

.p-seneca-the-younger {
  font-family: "GenEiKoburiMin";
  font-size: 13px;
  color: #493c33;
  text-align: right;
  width: 90%;
}

.seneca-img-wrapper img {
  width: 250px;
  height: 250px;
  object-fit: contain;
}

@media screen and (max-width: 570px) {

.seneca-section {
  flex-direction: column;
  gap: 0px;
}

.seneca-text-wrapper {
  width: 100%;
  margin-left: none;
}

.seneca-img-wrapper {
  width: 100%;
}

.first-quotation {
  font-size: 20px;
  height: 5px;
}

.last-quotation {
  font-size: 20px;
  height: 5px;

}

.p-On-the-Shortness-of-Life {
  font-size: 12px;
  width: 90%;
}

.p-seneca-the-younger {
  text-align: right;
  width: 100%;
  font-size: 12px;
  white-space: wrap;
}

.seneca-img-wrapper img {
    width: auto;
    height: 200px;
  }

}
</style>